import { Icon, Tooltip, Typography, TypographyProps } from '@mui/material';
import { GroupAgeGroup } from '@schooly/api';
import { ArchiveIcon } from '@schooly/style';
import { FC } from 'react';
import { useIntl } from 'react-intl';

type AgeGroupLabelProps = { ageGroup: GroupAgeGroup } & TypographyProps;

export const AgeGroupLabel: FC<AgeGroupLabelProps> = ({ ageGroup, ...props }) => {
  const { formatMessage } = useIntl();

  if (!ageGroup.archived) return <>{ageGroup.name}</>;

  return (
    <Tooltip title={formatMessage({ id: 'schoolProperty-Archived-age_group' })}>
      <Typography color="inherit" component="span" {...props}>
        <Icon sx={{ verticalAlign: 'middle', mb: 0.25, fontSize: 'inherit' }}>
          <ArchiveIcon />
        </Icon>{' '}
        {ageGroup.name}
      </Typography>
    </Tooltip>
  );
};
